import { toast } from "vue-sonner";

function handleProps(props, type) {
    if (typeof props === "string") {
        props = { description: props };
    }
    return type ? { ...props, type } : props;
}

function _toast(props) {
    toast(this, handleProps(props));
}

_toast.success = (props) => {
    toast(this, handleProps(props, "success"));
};

_toast.error = (props) => {
    toast(this, handleProps(props, "error"));
};

_toast.info = (props) => {
    toast(this, handleProps(props, "info"));
};

_toast.default = (props) => {
    toast(this, handleProps(props, "default"));
};

_toast.promise = (promise, props) => {
    toast.promise(promise, handleProps(props));
};

export { default as Toaster } from "./Toaster.vue";
export { _toast as toast };
